module.exports = __webpack_public_path__ + "static/media/item-4.bbef58bb.png";